import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'policyCssHelper'
})
export class PolicyCssHelperPipe implements PipeTransform {

  transform(value: any, type: string): unknown {
    const policyType = value.policies[type];
    if(policyType === 'Limit'){
      return 'input-group-custom'
    }else{
      return 'input-group-custom  input-disabled hidden'
    }
  }

}
